import { PAGES } from '../../constants';

export const textCommentariesConfig = {
    activeOnPages: [
        PAGES.LIVE_TAB
    ]
};



// WEBPACK FOOTER //
// ./lib/js/modules/textCommentaries/textCommentaries.config.js